module.exports = __webpack_public_path__ + "img/supba.72859dcf.png";